import React from 'react'
import "./Footer.css"

export default function Footer() {
    return (
        <div className="footer">
            <p>&copy; 2025 Zavod MARELA, Turnišče</p>
        </div>
    )
}
